export default "__VITE_ASSET__BKT$fmN1__"